import type { MantineSize, MantineTheme } from "@mantine/core"
import { useMediaQuery } from "@mantine/hooks"
import { theme } from "@/styles"

const breakpoints = theme.breakpoints as MantineTheme["breakpoints"]

export function useMinWidth(size: MantineSize) {
  return useMediaQuery(`(min-width: ${breakpoints[size]})`)
}
